import { TokenGestaoEmpresaTipoEnum } from "api/master/models/token/token-gestao-empresa-model";
import { TokenIntegradorModel } from "api/master/models/token/token-integrador-model";
import { getIDFromUrl } from "utils/get-id-url";
import { ConvertTokenIntegrador } from "utils/use-token";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface IObterToken {
    token: string | undefined
    getTokenConvert: (token?: string) => TokenIntegradorModel | undefined
    setToken: (token: string | undefined) => void
    isTokenExpired: (token?: string) => boolean
    getTokenTipo: () => TokenGestaoEmpresaTipoEnum | undefined
    rotaValida: () => boolean
    deslogar: () => void
}

export const useObterToken = create<IObterToken>()(
    persist((set, get) => ({
        token: undefined,

        getTokenConvert: (token?: string) =>
            ConvertTokenIntegrador(token ?? get().token ?? ''),

        setToken: (token: string | undefined) =>
            set({ token }),

        isTokenExpired: (token?: string) => {
            const tokenConvert = get().getTokenConvert(token)
            const isExpired = (((tokenConvert?.exp ?? 0) * 1000) <= new Date().getTime())
            if (!tokenConvert) return true
            if (isExpired) {
                set({ token: undefined })
            }
            return isExpired
        },

        getTokenTipo: () =>
            get()
                .getTokenConvert()?.empresa
                .find(empresa => empresa.Id === getIDFromUrl('empresaId'))
                ?.Perfil.Tipo,

        rotaValida: () => {
            const tokenConvert = get().getTokenConvert()
            return tokenConvert?.empresa.some(empresa => empresa.Id === getIDFromUrl('empresaId')) ?? false
        },

        deslogar: () => set({ token: undefined }),
    }), {
        name: 'token-usuario-store',
    })
)